import { getAlpha2Code } from 'i18n-iso-countries/index';
import type { CountryCode } from 'libphonenumber-js/min';

/** Supported regions, listed first in every phone country dropdown. */
export const SUPPORTED_PHONE_COUNTRIES: CountryCode[] = [
  'US',
  'CA',
  'GB',
  'IE',
];

/**
 * Resolves a country FULL NAME (what `shop.address.country` carries, e.g.
 * "United States") to the ISO alpha-2 code the phone input expects. Returns
 * undefined for unknown or missing names so callers keep their own default.
 */
export const getCountryCodeForName = (
  name?: string | null,
): CountryCode | undefined => {
  if (!name) return undefined;

  const code = getAlpha2Code(name, 'en');

  return code ? (code as CountryCode) : undefined;
};
